<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTORESPALDO.LBL_RESPALDO' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioRespaldo" name="nomFormularioRespaldo">

      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTORESPALDO.LBL_MONTOMINIMO' | translate }} ({{ 'PRODUCTORESPALDO.LBL_SMLV' | translate }})</label>
            <input type="text" pInputText id="idRangoInferior"
                   name="nomRangoInferior"
                   autocomplete="off" [entero]="7"
                   formControlName="rangoInferior" numero-decimal-reactive [decimales]="6" [minimo]="0"
                   [maxlength]="6"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoInferior.invalid">
              {{ 'PRODUCTORESPALDO.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="!rangoDesdeValido">
              {{ 'LBL_RANGOINVALIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTORESPALDO.LBL_MONTOMAXIMO' | translate }} ({{ 'PRODUCTORESPALDO.LBL_SMLV' | translate }})</label>
            <input type="text" pInputText id="idRangoSuperior"
                   name="nomRangoSuperior"
                   autocomplete="off"
                   formControlName="rangoSuperior" numero-decimal-reactive
                   [decimales]="6" [minimo]="0" [entero]="7"
                   [maxlength]="14"
                   (blur)="validarValor($event, true)"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoSuperior.invalid">
              {{ 'PRODUCTORESPALDO.LBL_MONTOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="!rangoDesdeValido">
              {{ 'LBL_RANGOINVALIDO' | translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTORESPALDO.LBL_RESPALDOS' | translate }}</label>
            <p-dropdown disableTab  id="idRespaldo" name="nomRespaldo" [options]="listaRespaldos"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idRespaldo"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idRespaldo.invalid">
              {{ 'PRODUCTOGARANTIA.LBL_PERFIL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>

        <div class="col-12 md:col-4 lg:col-4">
          <p-checkbox label="{{ 'PRODUCTORESPALDO.LBL_OBLIGATORIO' | translate}}" binary="true"
                      id="indicadorObligatorio"
                      name="nomIndicadorObligatorio"
                      formControlName="indicadorObligatorio"></p-checkbox>
        </div>

        <div class="col-12 md:col-4 lg:col-4">
          <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                      id="indicador"
                      name="nomIndicador"
                      formControlName="indicadorHabilitado"></p-checkbox>
        </div>


      </div>

      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" *ngIf="!edit"
                    label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
            <button icon="fa fa-plus" *ngIf="edit"
                    label="{{'BTN_EDITAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="proGarantia.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando" #proGarantia
                 [value]="segProductosRespaldos" selectionMode="single" dataKey="idProductoGarantia"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreRespaldo}}</td>
              <td>{{row.rangoMonto}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorObligatorio" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>

              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-danger btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="editar(row)" *ngIf="producto.indicadorHabilitado"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="garantias">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
